/* bs-product-reviews — "Opiniones" de la PDP (Bienestar Senior).

   Responsabilidades (todas scoped a cada instancia de .bs-product-reviews-root, R44-R48/R56):
     1. Filtros (pills __pill[data-bs-filter]): togglean data-verified/data-rating de las
        __card ya renderizadas server-side. Solo toggle de `hidden` nativo, sin fetch.
     2. Orden (select __sort-select): reordena los nodos __card en el grid por data-date
        (recientes) o data-rating (mejor valoradas), descendente.
     3. "Ver todas": revela las __card más allá de las primeras 4 que matchean el filtro activo.
     4. "Escribir opinión": dispara el form nativo de Judge.me (patrón SOKA, mismo que
        recipes/judge-me-reviews/reviews.liquid) sobre el widget oculto __judgeme-hidden.

   Visibilidad filtro + límite inicial se combinan en refreshVisibility(): se recalculan SIEMPRE
   en el orden actual del DOM (no en un índice fijo server-side) para que el límite de "primeras
   4" siga siendo correcto después de un reorder por __sort-select — evita el desajuste de que
   "Ver todas" revele las 4 originales en vez de las 4 visualmente primeras tras ordenar. */

(function () {
  'use strict';

  var VISIBLE_INITIAL = 4;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cardMatchesFilter(card, filterKey) {
    if (!filterKey || filterKey === 'all') return true;
    if (filterKey === 'verified') return card.dataset.verified === 'true';
    if (filterKey === '5' || filterKey === '4') return card.dataset.rating === filterKey;
    return true;
  }

  /* Recalcula qué __card se muestran: deben matchear el filtro activo Y (estar dentro del
     límite VISIBLE_INITIAL en el orden actual del DOM O el grid estar "expanded"). También
     muestra/oculta el botón "Ver todas" según si quedan cards ocultas por el límite. */
  function refreshVisibility(section) {
    var grid = section.querySelector('[data-bs-reviews-grid]');
    if (!grid) return;

    var cards = grid.querySelectorAll('.bs-product-reviews__card');
    var activeFilter = section.dataset.bsActiveFilter || 'all';
    var expanded = section.dataset.bsExpanded === 'true';

    var visibleIndex = 0;
    var totalMatches = 0;
    var i;

    for (i = 0; i < cards.length; i++) {
      if (cardMatchesFilter(cards[i], activeFilter)) totalMatches++;
    }

    for (i = 0; i < cards.length; i++) {
      var card = cards[i];
      var matches = cardMatchesFilter(card, activeFilter);
      if (!matches) {
        card.hidden = true;
        continue;
      }
      card.hidden = !(expanded || visibleIndex < VISIBLE_INITIAL);
      visibleIndex++;
    }

    var viewAllBtn = section.querySelector('[data-bs-view-all]');
    if (viewAllBtn) {
      viewAllBtn.hidden = expanded || totalMatches <= VISIBLE_INITIAL;
    }
  }

  function sortCards(section, criteria) {
    var grid = section.querySelector('[data-bs-reviews-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.bs-product-reviews__card'));
    cards.sort(function (a, b) {
      if (criteria === 'top') {
        return (parseInt(b.dataset.rating, 10) || 0) - (parseInt(a.dataset.rating, 10) || 0);
      }
      /* 'recent' (default): data-date es un unix timestamp (segundos) inyectado server-side */
      return (parseInt(b.dataset.date, 10) || 0) - (parseInt(a.dataset.date, 10) || 0);
    });

    /* appendChild sobre nodos ya adjuntos los mueve (no clona) — reordena in place. */
    cards.forEach(function (card) {
      grid.appendChild(card);
    });

    refreshVisibility(section);
  }

  function handleFilterClick(section, pill) {
    var pills = section.querySelectorAll('[data-bs-filter]');
    pills.forEach(function (p) {
      var isActive = p === pill;
      p.classList.toggle('bs-product-reviews__pill--active', isActive);
      p.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    section.dataset.bsActiveFilter = pill.dataset.bsFilter || 'all';
    refreshVisibility(section);
  }

  function handleViewAllClick(section) {
    section.dataset.bsExpanded = 'true';
    refreshVisibility(section);
  }

  /* CARGA LAZY de Judge.me (2026-07-15). El widget vive en la section SIN `data-entry-point`
     (ver bs-product-reviews.liquid) para que el loader de Judge.me NO lo cargue al entrar en la
     página — así la PDP se mantiene ligera. Al pulsar "Escribir una opinión" se activa aquí:
       1. Se revela el contenedor `[data-bs-judgeme-lazy]` (quita `hidden`).
       2. Se le añaden los `data-entry-point`/`data-entry-key` que el loader escanea.
       3. Se re-ejecuta el loader de Judge.me como MÓDULO (URL derivada de jdgm.CDN_BASE_URL,
          robusto ante cambios de versión del app embed). El loader re-escanea, encuentra el
          widget y renderiza el review widget + formulario.
       4. Cuando el widget renderiza, se hace scroll y se abre el form (click en su botón real).
     Solo se activa una vez por section (guard `bsJdgmBooted`). Fallback: si no renderiza en el
     tiempo previsto, deja el widget revelado para que el usuario lo use igualmente. */

  /* Botón real "Escribir una reseña" del widget renderizado. Judge.me v3 usa
     `.jm-action-buttons__button.jm-button--primary`; se dejan también los selectores legacy
     (`jdgm-*`) por si el merchant usa una versión antigua del widget. El botón puede aparecer
     unos ms después del primer render, así que se reintenta. */
  var WRITE_BTN_SELECTOR =
    '.jm-action-buttons__button.jm-button--primary, [data-testid="write-review-button"], .jdgm-write-rev-link, .jdgm-write-review-btn';

  function openJudgemeForm(section) {
    var attempts = 0;
    (function tryOpen() {
      var writeBtn = section.querySelector(WRITE_BTN_SELECTOR);
      if (writeBtn) {
        /* Abre el modal de "escribir reseña". El widget vive clipado (invisible) para no mostrar
           la sección de reseñas completa de la app; el modal se inyecta a nivel de <body>
           (overlay centrado), así que aparece por encima sin necesidad de scroll. */
        writeBtn.click();
        return;
      }
      if (attempts < 20) {
        attempts += 1;
        window.setTimeout(tryOpen, 250);
      }
      /* Si el botón nunca aparece (muy raro): no hay nada visible que mostrar (widget clipado);
         el usuario puede reintentar el clic (handleWriteReviewClick re-abre). */
    })();
  }

  function bootJudgeme(section, onDone) {
    var widget = section.querySelector('#judgeme_product_reviews');
    var jdgm = window.jdgm;
    if (!widget || !jdgm || !jdgm.CDN_BASE_URL) {
      onDone(false);
      return;
    }

    /* Atributos que el loader escanea para saber qué app cargar en este nodo. */
    widget.setAttribute('data-entry-point', 'review_widget.js');
    widget.setAttribute('data-entry-key', 'review-widget/main.js');

    /* Re-ejecutar el loader como módulo: resetea el guard interno y lo re-importa con un query
       único (evita la caché del módulo). Al re-correr, re-escanea el DOM y carga el widget. */
    try {
      delete jdgm._loaderExecuted;
    } catch (e) {
      /* algunos navegadores no dejan delete sobre props no configurables: no es crítico */
    }
    var loaderUrl = jdgm.CDN_BASE_URL + 'loader.js?bsrescan=' + Date.now();
    var script = document.createElement('script');
    script.type = 'module';
    script.src = loaderUrl;
    document.head.appendChild(script);

    /* Poll hasta que el widget tenga contenido renderizado (máx ~12s). */
    var tries = 0;
    (function poll() {
      if (widget.children.length > 0) {
        onDone(true);
        return;
      }
      if (tries >= 48) {
        onDone(false);
        return;
      }
      tries += 1;
      window.setTimeout(poll, 250);
    })();
  }

  function handleWriteReviewClick(section, btn) {
    var wrap = section.querySelector('[data-bs-judgeme-lazy]');
    if (wrap) wrap.hidden = false;

    /* Ya arrancado antes: solo re-abrir el form. */
    if (section.dataset.bsJdgmBooted === 'true') {
      openJudgemeForm(section);
      return;
    }
    section.dataset.bsJdgmBooted = 'true';

    /* Estado de carga en el botón (aria-busy para lectores de pantalla). */
    var labelEl = btn.querySelector('[data-bs-write-label]') || btn;
    var originalLabel = labelEl.textContent;
    btn.setAttribute('aria-busy', 'true');
    labelEl.textContent = 'Cargando…';

    bootJudgeme(section, function (rendered) {
      btn.removeAttribute('aria-busy');
      labelEl.textContent = originalLabel;
      if (rendered) {
        openJudgemeForm(section);
      } else {
        /* El widget no renderizó (red lenta / error de Judge.me). El contenedor está clipado, así
           que no hay nada que mostrar; permitimos reintentar el clic reseteando el guard. */
        section.dataset.bsJdgmBooted = '';
      }
    });
  }

  function initSection(section) {
    if (section.dataset.bsProductReviewsInit) return;
    section.dataset.bsProductReviewsInit = 'true';
    section.dataset.bsActiveFilter = 'all';
    section.dataset.bsExpanded = 'false';

    /* R47: listeners atados a la section (delegación), nunca a document/window */
    section.addEventListener('click', function (event) {
      var filterPill = event.target.closest('[data-bs-filter]');
      if (filterPill && section.contains(filterPill)) {
        handleFilterClick(section, filterPill);
        return;
      }

      var viewAllBtn = event.target.closest('[data-bs-view-all]');
      if (viewAllBtn && section.contains(viewAllBtn)) {
        handleViewAllClick(section);
        return;
      }

      var writeBtn = event.target.closest('[data-bs-write-review]');
      if (writeBtn && section.contains(writeBtn)) {
        handleWriteReviewClick(section, writeBtn);
        return;
      }
    });

    var sortSelect = section.querySelector('[data-bs-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortCards(section, sortSelect.value);
      });
    }

    /* Estado inicial: server ya renderizó las primeras VISIBLE_INITIAL visibles y el resto con
       `hidden` nativo (ver snippets/bs-product-review-card.liquid) — refrescar por si el orden
       server difiere del cálculo JS (defensivo, no debería cambiar nada en el primer render). */
    refreshVisibility(section);
  }

  function init(root) {
    var sections = (root || document).querySelectorAll('.bs-product-reviews-root');
    sections.forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('load', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bs-product-reviews-root');
    if (section) init(event.target);
  });
})();
